import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { ArgosHeader } from '@boltui/header-fetcher'
import ArgosFooter from '@boltui/footer'
import BoltTheme from '@boltui/bolt'
import { ThemeProvider } from 'styled-components'

import updateDigitalData from '../helpers/TaggingSerializer'
import { ErrorBoundary } from '../components'

class App extends React.Component {
  constructor () {
    super()
    this.onUserInfoLoad = this.onUserInfoLoad.bind(this)
  }

  onUserInfoLoad (userInfo) {
    updateDigitalData(userInfo)
    return {}
  }

  render () {
    return (
      <ThemeProvider theme={BoltTheme}>
        <div>
          <div>
            <ArgosHeader
              onSearchSubmit={this.handleSearch}
              onUserInfoLoad={this.onUserInfoLoad}
              skipToContentTag={'#storelocatormain'}
            />
          </div>

          <Helmet
            title='Argos Store Locator'
            meta={[
              { 'char-set': 'utf-8' },
              {
                name: 'description',
                content:
                  'Find a store using a postcode or town name. Find opening times and contact details. Buy online for free Fast Track in-store collection. Go Argos.'
              }
            ]}
            link={[{ rel: 'canonical', href: 'https://www.argos.co.uk/stores/' }]}
          />
          <div className='container-fluid' style={{ paddingRight: '0px', paddingLeft: '0px' }}>
            <ErrorBoundary>{this.props.children}</ErrorBoundary>
          </div>
          <div className='bolt-v2'>
            <ArgosFooter />
          </div>
        </div>
      </ThemeProvider>
    )
  }
}
App.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired
}

export default App



// WEBPACK FOOTER //
// ./src/containers/App.jsx